import { QueryParams } from './types';

export const initialParams: QueryParams = {
  builderIds: [],
  projectManagerIds: [],
  coordinatorIds: [],
  states: [],
  status: [],
  team: [],
  stages: [],
  open: [],
  statuses: [],
  workflowIds: [],
  taskIdentityIds: [],
  divisionIds: [],
  resourceDivisionIds: [],
  resourceSpecialtyIds: [],
  fieldUserIds: [],
  crewMemberIds: [],
  equipmentIds: [],
  crewTypes: [],
};
